import React, { Suspense } from 'react'
import { MainArticleLayout } from '../../layouts/MainArticleLayout'
import { LoaderProvider } from '../context/FormLoader'
import Protected from '../Protected'

const Profile = React.lazy(() => import('./Profile'))
const MyProfile = () => {
  return (
    <Protected>
      <Suspense fallback={null}>
        <MainArticleLayout>
          <LoaderProvider>
            <Profile />
          </LoaderProvider>
        </MainArticleLayout>
      </Suspense>
    </Protected>
  )
}

export default MyProfile
